// extracted by mini-css-extract-plugin
export default {"page":"ViewerPage_page__PrfkS","footerPosition":"ViewerPage_footerPosition__Ed4c7"};